import React, { useEffect, useState, useRef } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import "../../../admin_resources/css/admin_layout.css";
import "../../../admin_resources/css/admin_common.css";
import "../../../admin_resources/css/admin_style.css";
import ADMIN_HEADER from "../Admin_Header";
import axios from "axios";

const Admin_Qview = () => {
  const { idx } = useParams();
  const [applyItem, setApplyItem] = useState(null);
  const [, setApplyList] = useState([]);
  const navigate = useNavigate();

  const [, setSelectedFileName] = useState(""); // file2의 선택된 파일 이름
  const [, setFile1Name] = useState(""); // file1 이름 상태
  const [, setFile2] = useState(null);
  
  const [permissions, setPermissions] = useState({});

  // useRef를 컴포넌트 최상위에서 호출
  const fileInputRef = useRef(null); // useRef로 파일 입력란에 대한 참조를 생성

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 관리자 페이지`;

    const fetchApply = async () => {
      try {
        const response = await axios.get("/Formlist");
        const applys = response.data;
        const selectApply = applys.find(
          (social) => social.idx === parseInt(idx)
        );
        setApplyItem(selectApply);
      } catch (error) {
        console.error("Error fetching applys:", error);
      }
    };

    fetchApply();

	  // 관리자 권한 정보 가져오기
	  const adminId = localStorage.getItem("adminId");
	  if (adminId) {
	    fetchPermissions(adminId);
	  }
	}, [idx]);

	const fetchPermissions = async (adminId) => {
	  try {
	    const response = await fetch(`/permissions/${adminId}`); // 권한 확인 API 호출
	    const data = await response.json();
	    setPermissions(data); // 권한 정보를 상태로 설정
	  } catch (error) {
	    console.error("권한 정보를 가져오는 데 실패했습니다.", error);
	  }
	};

  // 삭제 요청을 처리하는 함수
  const handleDelete = async () => {
    // 사용자가 정말로 삭제할 것인지 확인하는 창
    if (window.confirm("삭제하시겠습니까?")) {
      try {
        const response = await axios.delete(`/form_delete/${applyItem.idx}`);
        if (response.status === 200) {
          alert("삭제되었습니다.");

          // 삭제 후 배너 목록을 갱신
          setApplyList((prevList) =>
            prevList.filter((social) => social.idx !== applyItem.idx)
          );

          // 삭제 후 목록 페이지로 이동
          navigate("/admin/form/q");
        }
      } catch (error) {
        console.error("삭제 실패:", error);
        alert("삭제에 실패했습니다.");
      }
    }
  };

  if (!applyItem) {
    return <div>로딩 중...</div>;
  }

  const handleUpdate = async () => {
    // 수정 확인 알림창
    const isConfirmed = window.confirm("수정하시겠습니까?");

    if (!isConfirmed) {
      return; // 사용자가 취소를 선택하면 폼 제출을 중단
    }

    const formData = new FormData();
    formData.append("procId", localStorage.getItem("adminId"));
    formData.append("procName", localStorage.getItem("adminName"));
    formData.append("name", applyItem.name);
    formData.append("subGubun", applyItem.subGubun);
    formData.append("babySchool", applyItem.babySchool);
    formData.append("cell", applyItem.cell);
    formData.append("os", applyItem.os);
    formData.append("deviceType", applyItem.deviceType);
    formData.append("content", applyItem.content);
    formData.append("etc", applyItem.etc);

    try {
      const response = await axios.put(
        `/form_update/${applyItem.idx}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 200) {
        alert("수정되었습니다.");
        window.location.href = "/admin/form/q";
      }
    } catch (error) {
      console.error("수정 실패:", error);
      alert("수정에 실패했습니다.");
    }
  };

  // 파일 선택 함수
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    // 파일이 선택되었을 때
    if (file) {
      setSelectedFileName(file.name);
      const timestamp = new Date()
        .toISOString()
        .replace(/[-:.T]/g, "")
        .slice(0, 14);
      const extension = file.name.split(".").pop();
      setFile1Name(`${timestamp}_.${extension}`); // file1 이름 상태 업데이트
      setFile2(file); // file2 상태 업데이트
    } else {
      setSelectedFileName("");
      setFile1Name(""); // 파일이 선택되지 않은 경우
      setFile2(null); // 잘못된 파일 상태 초기화

      // 파일 입력란 초기화
      fileInputRef.current.value = ""; // useRef로 파일 입력란 초기화
    }
  };

  return (
    <div>
      <ADMIN_HEADER />
      <div className="admin_view">
        <div className="path-sec">
          HOME &gt; <span className="menu1">데이터 관리</span> &gt;
          <span className="menu2"> 앱 문의 관리</span>
        </div>
        <table>
          <tr>
            <td>
              <div className="sec-snb">
                <h3 className="snb_tit">데이터 관리</h3>
                <ul className="snb_list">
				{permissions.ent && (
				  <li>
				    <a href="/admin/form/ent">입회신청 관리</a>
				  </li>
				)}
				{permissions.fr && (
				  <li>
				    <a href="/admin/form/fr">창업신청 관리</a>
				  </li>
				)}
				{permissions.franchise && (
				  <li>
				    <a href="/admin/form/franchise">가맹점 관리</a>
				  </li>
				)}
				{permissions.schedule && (
				  <li>
				    <a href="/admin/form/schedule">창업일정 관리</a>
				  </li>
				)}
				{permissions.jisa && (
				  <li>
				    <a href="/admin/form/jisa">지사장 지원 관리</a>
				  </li>
				)}
				{permissions.q && (
				  <li className="cur">
				    <a href="/admin/form/q">앱 문의 관리</a>
				  </li>
				)}
				{permissions.etc_q && (
				  <li>
				    <a href="/admin/form/etc_q">기타문의 관리</a>
				  </li>
				)}
                  {(localStorage.getItem("adminId") === "jiwoo" ||
                    localStorage.getItem("adminId") === "nixona" ||
                    localStorage.getItem("adminId") === "wjdrnr90" ||
                    localStorage.getItem("adminId") === "hyoseon.jang") && (
                    <li>
                      <a href="/admin/form/point">적립금 정산 관리</a>
                    </li>
                  )}
                </ul>
              </div>
            </td>
            <td>
              <div className="bx-top">앱 문의 확인</div>
              <form id="editform">
                <div className="tb_01 wr">
                  <table>
                    <tbody>
                      <tr>
                        <th>작성자</th>
                        <td>
                          <input
                            name="name"
                            value={applyItem.name}
                            type="text"
                            onChange={(e) =>
                              setApplyItem({
                                ...applyItem,
                                name: e.target.value,
                              })
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>카테고리</th>
                        <td>
                          <select
                            name="subGubun"
                            id="selectetc"
                            value={applyItem.subGubun}
                            onChange={(e) =>
                              setApplyItem({
                                ...applyItem,
                                subGubun: e.target.value, // select에서 선택된 값으로 applyItem 상태 업데이트
                              })
                            }
                          >
                            <option value="학부모">학부모</option>
                            <option value="지사">지사</option>
                            <option value="교육원">교육원</option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <th>교육원명</th>
                        <td>
                          <input
                            name="babySchool"
                            value={applyItem.babySchool}
                            type="text"
                            onChange={(e) =>
                              setApplyItem({
                                ...applyItem,
                                babySchool: e.target.value,
                              })
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>연락처</th>
                        <td>
                          <input
                            name="cell"
                            value={applyItem.cell}
                            type="text"
                            maxLength="11"
                            onChange={(e) =>
                              setApplyItem({
                                ...applyItem,
                                cell: e.target.value,
                              })
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>OS버전</th>
                        <td>
                          <select
                            name="os"
                            id="selectetc"
                            value={applyItem.os}
                            onChange={(e) =>
                              setApplyItem({
                                ...applyItem,
                                os: e.target.value, // select에서 선택된 값으로 applyItem 상태 업데이트
                              })
                            }
                          >
                            <option value="android">Android</option>
                            <option value="ios">IOS</option>
                            <option value="und">모름</option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <th>기종</th>
                        <td>
                          <input
                            name="deviceType"
                            value={applyItem.deviceType}
                            type="text"
                            onChange={(e) =>
                              setApplyItem({
                                ...applyItem,
                                deviceType: e.target.value,
                              })
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>문의사항</th>
                        <td>
                          <textarea
                            name="content"
                            value={applyItem.content}
                            type="text"
                            onChange={(e) =>
                              setApplyItem({
                                ...applyItem,
                                content: e.target.value,
                              })
                            }
                            style={{ height: "200px" }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>첨부파일</th>
                        <td id="fd">
                          <input
                            id="upload"
                            name="file2"
                            type="file"
                            class="inputtext"
                            onChange={handleFileChange}
                            ref={fileInputRef} // ref를 통해 입력 필드에 접근
                          />
						  첨부파일 :{applyItem.file2}
						  {applyItem.file2 ? (
						    <a
						      href={`/DATA/upload/${applyItem.file1}`}
						      download={applyItem.file2}
						      onClick={(e) => e.stopPropagation()} // 이벤트 버블링 방지
						      style={{
						        border: "1px solid",
						        borderRadius: "3px",
						        padding: "5px",
						        marginLeft: "5px",
						        backgroundColor: "#e1dede",
						      }}
						    >
						      다운로드
						    </a>
						  ) : (
						    "파일이 없습니다"
						  )}
                          <ul>
                            <li>
                              ※ 파일이 여러개인 경우 압축하여 업로드 해주세요.
                            </li>
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <th>진행상황</th>
                        <td>
                          <select
                            name="etc"
                            id="selectetc"
                            value={applyItem.etc}
                            onChange={(e) =>
                              setApplyItem({
                                ...applyItem,
                                etc: e.target.value, // select에서 선택된 값으로 applyItem 상태 업데이트
                              })
                            }
                          >
                            <option value="미정">미정</option>
                            <option value="진행중">진행중</option>
                            <option value="전달완료">전달완료</option>
                            <option value="개선사항">개선사항</option>
                          </select>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </form>
              <div className="view-btn">
                <span className="btn custom_s">
                  <button>
                    <Link to="/admin/form/q" style={{ color: "#fff" }}>
                      목록
                    </Link>
                  </button>
                </span>

                <div className="btn-right">
                  <span className="btn custom_r">
                    <button onClick={handleUpdate}>수정</button>
                  </span>
                  <span className="btn custom_d">
                    <button onClick={handleDelete}>삭제</button>
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default Admin_Qview;
